import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { COLORS } from "../config/theme/baseTheme";
import { chipContainerStyles, excelDownloadStyles, tagStyles, useDialogPaperPropsRootStyle, usePublishRouteDialogStyle } from "SharedComponent/styles/sharedStyles";

export const useStyles = makeStyles((theme: Theme) => {

      const {
          publishDialogPaperPropsRoot,
          deleteDialogPaperPropsRoot,
          publishDialogContentContainer,
          hubSelectionDialogPaperPropsRoot
      } = useDialogPaperPropsRootStyle(theme);
  
      const {
          hubSelectionDialogTitle,
          hubSelectionDialogContentContainer,
          publishDialogButtonsContainer,
          deleteDialogButtonsContainer,
          hubSelectionDialogButtonsContainer,
          deleteDialogContentContainer,
          publishErrorPopupContainer
      } = usePublishRouteDialogStyle(theme);

       const {
          excelDownloadStatus,
          excelDownloadStatusText,
          checkedIconStyle,
          close,
          closeIcon,
          excelDownloadError,
        } = excelDownloadStyles(theme);

 return  createStyles({
    root: {
      height: "100%",
    },
    container: {
      flexDirection: "column",
      '& .planningItem': {
        width: '100%',
        '& .MuiTab-root': {
          marginRight: 24,
          color: COLORS.DUSTY_GRAY
        },
        "& .MuiTab-root.Mui-selected": {
          color: '#1F1F1F'
        },
        '&.heading': {
          '& p': {
            fontSize: 20,
            lineHeight: "30px",
            color: COLORS.PRIMARY_MAIN,
            fontFamily: "Montserrat",
            fontWeight: 600,
          }
        },
        '&.content': {
          backgroundColor: COLORS.WHITE,
          borderRadius: theme.spacing(1),
          height: "calc(100vh - 172px)",
          '& .tabPanel': {
            height: "calc(100% - 56px)",
            padding: "0px 12px 20px 12px",
            '&.routes': {
              position: "relative"
            }
          }
        }
      },
      '& .customButton':{
        backgroundColor: "unset !important" ,
        color: COLORS.ALIZARIN_CRIMSON,
        '&:hover': {
          backgroundColor: "unset !important"
        },
        '&::before': {
          display: "inline-block",
          content: "url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMTIiIGZpbGw9IiNGN0Y4RjkiLz4KPHBhdGggZD0iTTE2LjEyNSA4LjYyNUw3Ljg3NSA4LjYyNTAxIiBzdHJva2U9IiNDRTM2MzciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTAuODc1IDEwLjg3NVYxMy44NzUiIHN0cm9rZT0iI0NFMzYzNyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMy4xMjUgMTAuODc1VjEzLjg3NSIgc3Ryb2tlPSIjQ0UzNjM3IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE1LjM3NSA4LjYyNVYxNS43NUMxNS4zNzUgMTUuODQ5NSAxNS4zMzU1IDE1Ljk0NDggMTUuMjY1MiAxNi4wMTUyQzE1LjE5NDggMTYuMDg1NSAxNS4wOTk1IDE2LjEyNSAxNSAxNi4xMjVIOUM4LjkwMDU0IDE2LjEyNSA4LjgwNTE2IDE2LjA4NTUgOC43MzQ4NCAxNi4wMTUyQzguNjY0NTEgMTUuOTQ0OCA4LjYyNSAxNS44NDk1IDguNjI1IDE1Ljc1VjguNjI1IiBzdHJva2U9IiNDRTM2MzciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTMuODc1IDguNjI1VjcuODc1QzEzLjg3NSA3LjY3NjA5IDEzLjc5NiA3LjQ4NTMyIDEzLjY1NTMgNy4zNDQ2N0MxMy41MTQ3IDcuMjA0MDIgMTMuMzIzOSA3LjEyNSAxMy4xMjUgNy4xMjVIMTAuODc1QzEwLjY3NjEgNy4xMjUgMTAuNDg1MyA3LjIwNDAyIDEwLjM0NDcgNy4zNDQ2N0MxMC4yMDQgNy40ODUzMiAxMC4xMjUgNy42NzYwOSAxMC4xMjUgNy44NzVWOC42MjUiIHN0cm9rZT0iI0NFMzYzNyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=)",
          paddingTop:4,
          paddingRight: 2
        }
      }
    },
    tabPanelContainer: {
      flexDirection: "column",
      height: "100%",
      '& .panelItem': {
        width: "100%",
        '&.chipFilter': {
          padding: "12px 0px 10px 0px",
          '& .chipsContainer': {
            justifyContent: 'space-between',
            '& .chipFilterItem': {
              height: 36,
              minWidth: "11%",
              borderRadius: theme.spacing(1),
              border: `1px solid ${COLORS.TRANSPARENT_BLUE_BORDER}`,
              backgroundColor: COLORS.TRANSPARENT_BLUE,
              cursor: "pointer",
              '&:last-child': {
                marginRight: 0
              },
              '&.firstItem': {
                boxShadow: `0px 0px 10px 4px ${COLORS.BOX_SHADOW_PRIMARY}`,
                border: `2px solid ${theme.palette.primary.main}`
              },
              '&.active': {
                background: COLORS.AZURE_BLUE,
                border: "none",
                boxShadow: "none",
                '& .chipItem p': {
                  color: COLORS.WHITE
                }
              },
              ...chipContainerStyles(theme)
            }
          }
        },
        '&.gridWrapper': {
          height: "calc(100% - 98px)",
          '& .consignmentDivStyle': {
            display: 'flex',
            margin: 'auto 0px'
          },
          '& .idLink': {
            cursor: "pointer",
            color: theme.palette.primary.main,
            fontWeight: 600,
            fontSize: 12,
            margin: 'auto 0px'
          }
        }
      }
    },
    publishDialogContentContainer,
     publishDialogPaperPropsRoot,
        deleteDialogPaperPropsRoot,
        hubSelectionDialogPaperPropsRoot,
        hubSelectionDialogTitle,
        hubSelectionDialogContentContainer,
        publishDialogButtonsContainer,
        deleteDialogButtonsContainer,
        hubSelectionDialogButtonsContainer,
        deleteDialogContentContainer,
    publishErrorPopupContainer,
    actionsHeader: {
      alignItems: "center",
      '& .actionItem': {
        cursor: "pointer",
        '& .icon': {
          padding: theme.spacing(0.25),
          '&.editIcon': {
            marginRight: theme.spacing(0.75)
          }
        }
      }
    },
    deliveryAreaHeader: {
      alignItems: "center",
      '& .columnValue': {
        fontSize: 12
      }
    },
    statusHeaderContainer: {
      '& .tag': {
        ...tagStyles(theme).base,
        '&.PICTON_BLUE': {
          backgroundColor: COLORS.PICTON_BLUE
        },
        '&.CREAM_CAN': {
          backgroundColor: COLORS.CREAM_CAN
        },
        '&.VISTA_BLUE': {
          backgroundColor: COLORS.VISTA_BLUE
        },
        '&.SEA_GREEN': {
          backgroundColor: COLORS.SEA_GREEN
        },
        '&.GOLDEN_BELL': {
          backgroundColor: COLORS.GOLDEN_BELL
        },
        '&.SCAMPI': {
          backgroundColor: COLORS.SCAMPI
        },
        '&.BLUE': {
          backgroundColor: COLORS.PRIMARY_MAIN
        },
        '&.SEA_GREEN2': {
          backgroundColor: COLORS.SEA_GREEN2
        },
        '&.LUCKY': {
          backgroundColor: COLORS.LUCKY
        },
        '&.DUSTY_GRAY': {
          backgroundColor: COLORS.DUSTY_GRAY
        },
        '&.JUNGLE_GREEN': {
          backgroundColor: COLORS.JUNGLE_GREEN
        },
        '&.BLACK': {
          backgroundColor: COLORS.BLACK
        },
        '&.TROPICAL_BLUE': {
          backgroundColor: COLORS.TROPICAL_BLUE,
          color: COLORS.ASTRAL
        },
        '&.CATSKILL_WHITE': {
          backgroundColor: COLORS.CATSKILL_WHITE,
          color: COLORS.ASTRAL
        },
        '&.BLUE_HAZE': {
          backgroundColor: COLORS.BLUE_HAZE,
          color: COLORS.SCAMPI
        },
        '&.BARLEY_WHITE': {
          backgroundColor: COLORS.BARLEY_WHITE,
          color: COLORS.OLD_GOLD
        },
        '&.DOUBLE_PEARL_LUSTA': {
          backgroundColor: COLORS.DOUBLE_PEARL_LUSTA,
          color: COLORS.PIMPKIN_SKIN
        },
        '&.JAGGED_ICE': {
          backgroundColor: COLORS.JAGGED_ICE,
          color: COLORS.BLUE_STONE
        },
        '&.TARA': {
          backgroundColor: COLORS.TARA,
          color: COLORS.OCEAN_GREEN
        },
        '&.JAGGED_ICE_PREPARED': {
          backgroundColor: COLORS.JAGGED_ICE,
          color: COLORS.JUNGLE_GREEN
        },
        '&.ALTO': {
          backgroundColor: COLORS.ALTO,
          color: COLORS.DUSTY_GRAY_LIGHT
        },
        '&.MINSK': {
          backgroundColor: COLORS.SCAMPI,
          color: COLORS.WHITE
        },
      
      }
    },
    subRouteId:{
      display:'flex',
      textAlign:'end',
      '& .tag': {
        ...tagStyles(theme).base,
        fontSize: 10,
        '&.subRoute':{
          backgroundColor: COLORS.INFO_BLUE,
          color: COLORS.WHITE,
          margin: "auto 4px"
        }
      }
    },
    excelDownloadStatus,
    excelDownloadStatusText,
    checkedIconStyle,
    close,
    closeIcon,
    excelDownloadError,
    parenRouteTag:{
      color: COLORS.WHITE,
      borderRadius: theme.spacing(0.5),
      padding: theme.spacing(0.25, 0.5),
      lineHeight: "14px",
      backgroundColor: COLORS.OLD_GOLD,
      fontWeight: 600,
      fontSize: 10,
      margin: "auto 4px"
    },
    subRouteTag:{
      ...tagStyles(theme).base,
      fontSize: 10,
      margin: "auto 4px"
    },
    customFilter: {
      display: "flex",
      alignItems: "center",
      padding: "4px 12px",
      borderRadius: "38px",
      backgroundColor: "#F7F8F9", // Static gray background for the badge
      fontWeight: "bold",
      textAlign: "center",
      border: '1px solid #EBF0F5'
    },
  })
})
